import { FANTOM, BSC } from "./chains";

export const GMX_STATS_API_URL = "https://trade-stats.lif3.com/api";

const BACKEND_URLS = {
  default: "https://trade-api.lif3.com",

  [FANTOM]: "https://trade-api.lif3.com",
  [BSC]: "https://trade-api-bsc1.lif3.com"
};

export function getServerBaseUrl(chainId: number) {
  if (!chainId) {
    throw new Error("chainId is not provided");
  }

  if (document.location.hostname.includes("deploy-preview")) {
    const fromLocalStorage = localStorage.getItem("SERVER_BASE_URL");
    if (fromLocalStorage) {
      return fromLocalStorage;
    }
  }

  return BACKEND_URLS[chainId] || BACKEND_URLS.default;
}

export function getServerUrl(chainId: number, path: string) {
  return `${getServerBaseUrl(chainId)}${path}`;
}
